import React, { useMemo } from "react";

import { Box } from "@chakra-ui/react";
import { TKybJobStatus } from "api/business-user-management/types";
import { TComplianceStatus } from "api/compliance/types";
import { ReactComponent as CopyIcon } from "assets/icons/copy.svg";
import { handleCopyToClipboard } from "utils";
import { Maybe } from "utils/general/maybe";

import { BusinessContentItem } from "./BusinessContentItem";
import { ComplianceStatus } from "./ComplianceStatus";
import { IBusinessContentItem, IFaceVerificationProps } from "./types";

export const jobStatusTextMap: Record<
  TKybJobStatus,
  {
    status: TComplianceStatus;
    text: string;
  }
> = {
  pending: {
    status: "pending",
    text: "Pending",
  },
  success: {
    status: "approved",
    text: "Success",
  },
  failed: {
    status: "rejected",
    text: "Failed",
  },
};
export const FaceVerification = (props: IFaceVerificationProps) => {
  const { business, isContentWrapperBelow745, isContentWrapperBelow600 } =
    props;

  const handleCopyItem = async (item: string, itemLabel: string) => {
    await handleCopyToClipboard(
      item ?? "",
      `${itemLabel} Copied Successfully!`
    );
  };

  const faceVerification: IBusinessContentItem[] = useMemo(
    () => [
      {
        title: "Liveness Check",
        content: business?.business?.companyData?.livenessCheck ? (
          <ComplianceStatus
            status={
              business?.business?.companyData?.livenessCheck?.toLowerCase() ===
              "passed"
                ? "approved"
                : "rejected"
            }
            text={
              business?.business?.companyData?.livenessCheck?.toLowerCase() ===
              "passed"
                ? "Passed"
                : "Failed"
            }
            className="w-fit"
          />
        ) : (
          "N/A"
        ),
      },
      {
        title: "Job ID",
        content: (
          <Box className="flex items-center gap-2">
            <p>{business?.business?.companyData?.livenessReference || "N/A"}</p>
            <Maybe
              condition={!!business?.business?.companyData?.livenessReference}
            >
              <CopyIcon
                cursor="pointer"
                onClick={() =>
                  handleCopyItem(
                    business?.business?.companyData?.livenessReference || "",
                    "Job ID"
                  )
                }
              />
            </Maybe>
          </Box>
        ),
      },
      {
        title: "Job Status",
        content: business?.business?.companyData?.kybJobStatus ? (
          <Box className="flex items-center gap-2">
            <ComplianceStatus
              status={
                jobStatusTextMap[business?.business?.companyData?.kybJobStatus]
                  .status
              }
              text={
                jobStatusTextMap[business?.business?.companyData?.kybJobStatus]
                  .text
              }
            />
          </Box>
        ) : (
          <p>N/A</p>
        ),
      },
    ],
    [isContentWrapperBelow745, isContentWrapperBelow600, business]
  );

  return (
    <Box>
      <Box
        css={{
          display: "flex",
          flexWrap: "wrap",
          columnGap: "32px",
          rowGap: "16px",
          justifyContent: "space-between",
        }}
      >
        {faceVerification.map(({ title, content }, index) => (
          <BusinessContentItem
            key={index}
            title={title}
            content={content}
            isContentWrapperBelow745={isContentWrapperBelow745}
            isContentWrapperBelow600={isContentWrapperBelow600}
          />
        ))}
      </Box>
    </Box>
  );
};
